import Vue from 'vue';
import Vuex from 'vuex';
import * as gmaps from '@/store/modules/gmaps.js';
import * as threads from '@/store/modules/threads.js';
//import * as layers from '@/store/modules/layers.js'
import layers from '@/store/modules/layers/index.js';
import * as general from '@/store/modules/general.js';
import * as phases from '@/store/modules/phases.js';
import * as loading from '@/store/modules/loading.js';

Vue.use(Vuex);

export const namespaced = false;

export default new Vuex.Store({
  modules: {
    gmaps,
    threads,
    layers,
    general,
    phases,
    loading
  },
  state: {},
  mutations: {},
  actions: {},
  getters: {}
});
